import { render } from "./About.vue?vue&type=template&id=09dffeae"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=09dffeae&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__